import dayjs from "dayjs";

export function getFormInputsValue(formElements) {
  const formData = {};
  for (const formInput of formElements) {
    if (!formInput.name) continue;
    if (formInput.type === "radio" && formInput.checked) {
      formData[formInput.name] = formInput.value;
    } else if (formInput.type === "radio" && !formInput.checked) {
      continue;
    }
    formData[formInput.name] = formInput.value;
  }
  return formData;
}

export function getFormatDynamicRoute(id, route) {
  return id ? `${route}${id}` : `${route}:id`;
}

export function formatDateDash(date) {
  return date.split("/").reverse().join("-");
}

export const eighteenYearAgo = dayjs().subtract(567993600000, "millisecond");

export const isPWA = () => {
  return window.matchMedia("(display-mode: standalone)").matches;
};
export const isWebView = () => {
  return window?.isRNWebView;
};
export const isAndroidWebView = () => {
  return window?.RNPlatform === "android";
};

export const isIOSWebView = () => {
  return window?.RNPlatform === "ios";
};
